export default {
  GET_ERROR_API: 'GET_ERROR_API',
};
